  /**
 * External dependencies
 */
import { get, omit, forOwn, omitBy, values } from 'lodash';

/**
 * Internal
 */
import { createReducer, appendToEditsLog } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.EDIT_CONNECTION_PAYMENT_TYPES]: (state, action) => {
            const id = action.payload.id || '';
            const connectionPaymentTypes = action.payload.connectionPaymentTypes;
            const newEditLogs = appendToEditsLog(get(state, id), connectionPaymentTypes);

            return {
                ...state,
                [id]: newEditLogs,
            };
        },
        [actions.EDIT_CONNECTION_PAYMENT_TYPES]: (state, action) => {
            const id = action.payload.id || '';
            return omit(state, id);
        },
    },
);